export default __webpack_public_path__ + "static/media/listmode.271445dc.svg";